import _ from '@lodash';
import NamedDto from 'modules/base/dto/NamedDto';
import InfrastructureElementType from './InfrastructureElementType';

export class InfrastructureElementTableDto extends NamedDto {
	constructor() {
		super();
		/** @type {NamedDto} */
		this.elementType = null;
		/** @type {string} */
		this.coordLat = null;
		/** @type {string} */
		this.coordLng = null;
		/** @type {NamedDto[]} */
		this.locationList = null;
		/** @type {NamedDto} */
		this.project = null;
	}

	/**
	 * @typedef {Object} _InfrastructureElementTableDtoProps
	 * @property {NamedDto} elementType
	 * @property {string} coordLat
	 * @property {string} coordLng
	 * @property {NamedDto[]} locationList
	 * @property {NamedDto} project
	 * @typedef {import("../NamedDto").NamedDtoProps & _InfrastructureElementTableDtoProps} InfrastructureElementTableDtoProps
	 */
	/**
	 *
	 * @param {InfrastructureElementTableDtoProps} props
	 * @returns {InfrastructureElementTableDto}
	 */
	setup(props) {
		super.setup(props);
		this.elementType = props.elementType !== null ? new NamedDto().setup(props.elementType) : null;
		this.coordLat = props.coordLat;
		this.coordLng = props.coordLng;
		this.locationList = props.locationList !== null ? props.locationList.map(d => new NamedDto().setup(d)) : null;
		this.project = props.project !== null ? new NamedDto().setup(props.project) : null;
		return this;
	}

	getAsString(key) {
		if (key === 'elementType') {
			return this.elementType ? InfrastructureElementType[this.elementType] : '';
		}
		if (key === 'locationList') {
			return _.isArray(this.locationList) ? this.locationList.map(d => d.name).join(', ') : '';
		}

		return super.getAsString(key);
	}
}

export default InfrastructureElementTableDto;
